import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ControlsOf, FormControl, FormGroup } from '@ngneat/reactive-forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Entity } from 'src/app/classes/entity.class';
import { Settlement } from 'src/app/classes/settlement.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { AfasService } from 'src/app/services/afas.service';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AfasProject } from '../../../afas-classes/afas-project';
import { Hourtype } from '../../../afas-classes/hourtype';

@Component({
    selector: 'app-edit-settlement-dialog',
    templateUrl: './edit-settlement-dialog.component.html',
    styleUrls: ['./edit-settlement-dialog.component.scss'],
    standalone: false,
})
export class EditSettlementDialogComponent extends CodaltComponent implements OnInit {
    projects: AfasProject[];

    form: FormGroup<ControlsOf<SettlementFormGroup>>;

    entities: Entity[];
    step = 'project';
    hourtypes: Hourtype[];

    fcProjectSearch = new FormControl<string>();

    searching = false;
    itemSearch: string;

    settlement: Settlement;

    constructor(
        public dialogRef: MatDialogRef<EditSettlementDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            settlement: Settlement;
            bookdate: Date;
            editOnly: string;
        },
        private settlementsService: SettlementsService,
        private afasService: AfasService
    ) {
        super();
        this.settlement = data.settlement;
        if (data.editOnly) {
            this.step = data.editOnly;
        }
        this.setCurrentProjects();
    }

    private setCurrentProjects() {
        this.projects = [];
    }

    ngOnInit(): void {
        this.form = new FormGroup<ControlsOf<SettlementFormGroup>>({
            id: new FormControl(this.settlement.id),
            afas_project_id: new FormControl(this.settlement.afas_project_id),
            afas_employee_id: new FormControl(this.settlement.afas_employee_id),
            hourtype_code: new FormControl(this.settlement.hourtype_code),
            minutes: new FormControl(this.settlement.minutes),
            amount: new FormControl(this.settlement.amount),
            bookdate: new FormControl(this.settlement.bookdate),
            updated_at: new FormControl(this.settlement.updated_at),
        });

        this.subscriptions.add(
            this.settlementsService.getHourtypes().subscribe(hourtypes => {
                this.hourtypes = hourtypes.data;
            })
        );

        let afasSubs = new Subscription();
        this.subscriptions.add(
            this.fcProjectSearch.valueChanges.pipe(debounceTime(200)).subscribe(search => {
                afasSubs?.unsubscribe();
                if (search) {
                    this.searching = true;
                    afasSubs = this.afasService.getProjects(search).subscribe(
                        projectResponse => {
                            this.projects = projectResponse.data;
                            this.searching = false;
                        },
                        () => {
                            this.searching = false;
                        }
                    );
                }
            })
        );

        const s = this.settlement;
        const defaultProject =
            s.afas_project_id ??
            s.realisation?.afas_project_id ??
            s.realisation?.planning?.afas_project_id ??
            s.realisation?.planning?.worknumber;
        if (defaultProject?.length > 0) {
            this.fcProjectSearch.setValue(defaultProject);
        }
    }

    saveAndClose() {
        this.subscriptions.add(
            this.settlementsService.save(this.form.value as any).subscribe(() => {
                this.dialogRef.close();
            })
        );
    }
}

interface SettlementFormGroup {
    id: number;
    afas_project_id: string;
    afas_employee_id: string;
    hourtype_code: string;
    minutes: number;
    amount?: string;
    bookdate: FormControl<Date>;
    updated_at: FormControl<Date>;
}
